import { fetchData } from './fetchData';
import { DefaultResponseData } from './data/DefaultResponseData';

type VerifyCodeCheckRequestData = {
    verify_code: string,
    login: string,
};

type VerifyCodeCheckResponseData = DefaultResponseData & {
    login: string,
};

function verifyCodeCheck(data: VerifyCodeCheckRequestData): Promise<VerifyCodeCheckResponseData> {
    return fetchData('api/verify_code_check', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: VerifyCodeCheckResponseData) => resData);
}

export { verifyCodeCheck };
